import React, { useEffect, useState } from "react";
import Tab from "../tab/Tab";
import "./faq.css";

import { publicApiClient } from "../../../api/apiClient";

const FAQ_API = "/api/contact/faq";

const getArrayData = (result) => {
  const data = result?.data;

  if (Array.isArray(data)) return data;

  if (Array.isArray(data?.content)) return data.content;
  if (Array.isArray(data?.contents)) return data.contents;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.list)) return data.list;

  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.data?.content)) return data.data.content;

  return [];
};

const normalizeFaq = (item, index) => ({
  id: item.faqId || item.id || index,
  q: item.question || item.q || "",
  a: item.answer || item.a || "",
});

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(null);
  const [faqList, setFaqList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const toggleFAQ = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  useEffect(() => {
    const fetchFaqList = async () => {
      try {
        setIsLoading(true);

        const result = await publicApiClient(FAQ_API);

        console.log("FAQ 조회 성공:", result);

        const formattedFaqList = getArrayData(result)
          .map(normalizeFaq)
          .filter((faq) => faq.q || faq.a);

        setFaqList(formattedFaqList);
      } catch (error) {
        console.error("FAQ 조회 실패:", error);
        setFaqList([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchFaqList();
  }, []);

  return (
    <>
      <Tab />

      <section className="faq-container">
        <h2 className="faq-title">자주 묻는 질문</h2>

        <div className="faq-box-wrap">
          <div className="faq-list">
            {isLoading ? (
              <p className="faq-empty">FAQ를 불러오는 중입니다.</p>
            ) : faqList.length > 0 ? (
              faqList.map((item, i) => (
                <div
                  key={item.id}
                  className={`faq-item ${openIndex === i ? "open" : ""}`}
                  onClick={() => toggleFAQ(i)}
                >
                  <div className="faq-question">
                    <span className="faq-icon"></span>
                    <span>{item.q}</span>
                  </div>

                  {openIndex === i && (
                    <div className="faq-answer">{item.a}</div>
                  )}
                </div>
              ))
            ) : (
              <p className="faq-empty">등록된 FAQ가 없습니다.</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
}